<template>
  <div class="renewal-detail" id="bottomBox" v-if="renewalDetail.id">
    <div class="renewal-content" :class="{ bottom0: !hasBtn }">
      <div class="status-box" v-if="renewalDetail.payState == 1">
        <i class="icon-xiangqing-daijiaofei"></i>
        <div class="info-box">
          <div class="text1">即将到期——{{ renewalDetail.endDesc }}</div>
          <div class="text2">到期日：{{ renewalDetail.endTime | formatTime('YYYY/MM/DD') }}</div>
        </div>
      </div>
      <div class="status-box green" v-if="renewalDetail.payState == 2">
        <i class="icon-xiangqing-yijiaofei"></i>
        <div class="info-box">
          <div class="text1">已续保</div>
          <div class="text2">原单到期日：{{ renewalDetail.endTime | formatTime('YYYY/MM/DD') }}</div>
        </div>
      </div>
      <div class="status-box" v-if="renewalDetail.payState == 3">
        <i class="icon-xiangqing-jiaofeishibai"></i>
        <div class="info-box">
          <div class="text1">未续保</div>
          <div class="text2">到期日：{{ renewalDetail.endTime | formatTime('YYYY/MM/DD') }}</div>
        </div>
      </div>
      <div class="detail-box">
        <div class="product-name">{{ renewalDetail.productName }}</div>
        <div class="detail-item">
          <div class="label">保单号</div>
          <div class="text-box">
            <div class="text1">{{ renewalDetail.policyNo }}</div>
            <div class="btn" id="copy1" @click="copy('copy1', renewalDetail.policyNo)">复制</div>
          </div>
        </div>
        <div class="detail-item">
          <div class="label">保单生效日</div>
          <div class="text1">{{ renewalDetail.startTime | formatTime('YYYY/MM/DD') }}</div>
          <div class="copmpeny-name">{{ renewalDetail.companyName }}</div>
        </div>
        <div class="detail-item">
          <div class="label">保单到期日</div>
          <div class="text1">{{ renewalDetail.endTime | formatTime('YYYY/MM/DD') }}</div>
        </div>
        <div class="detail-item">
          <div class="label">保单状态</div>
          <div class="text1">{{ renewalDetail.policyStatusDesc }}</div>
        </div>
        <div class="detail-item">
          <div class="label">现业务员</div>
          <div class="text1">{{ renewalDetail.salesmanName }}</div>
        </div>
        <div class="detail-item">
          <div class="label">投保人</div>
          <div class="text-box">
            <div class="text1">{{ renewalDetail.holderName }}</div>
          </div>
        </div>
        <div class="detail-item">
          <div class="label">原单保费</div>
          <div class="text-box">
            <div class="text1">{{ renewalDetail.fee }}元</div>
            <div class="btn2 btn-blue" @click="goServiceDetail(renewalDetail.policyNo, renewalDetail.orderNo)">服务费明细<i class="icon-right"></i></div>
          </div>
        </div>
      </div>
      <div class="detail-box top0" v-if="renewalDetail.newPolicyNo">
        <div class="big-detail-title">续保产品信息</div>
        <div class="product-name">{{ renewalDetail.newProductName }}</div>
        <div class="detail-item">
          <div class="label">保单号</div>
          <div class="text-box">
            <div class="text1 new-policy-no" @click="goPolicyDetail()">{{ renewalDetail.newPolicyNo }}</div>
            <div class="btn" id="copy2" @click="copy('copy2', renewalDetail.newPolicyNo)">复制</div>
          </div>
        </div>
        <div class="detail-item">
          <div class="label">保单生效日</div>
          <div class="text1">{{ renewalDetail.newStartTime | formatTime('YYYY/MM/DD') }}</div>
          <div class="copmpeny-name">{{ renewalDetail.newCompanyName }}</div>
        </div>
        <div class="detail-item">
          <div class="label">保单状态</div>
          <div class="text1">{{ renewalDetail.newPolicyStatusDesc }}</div>
        </div>
        <div class="detail-item">
          <div class="label">现业务员</div>
          <div class="text1">{{ renewalDetail.newSalesmanName }}</div>
        </div>
        <div class="detail-item">
          <div class="label">投保人</div>
          <div class="text-box">
            <div class="text1">{{ renewalDetail.newHolderName }}</div>
          </div>
        </div>
        <div class="detail-item">
          <div class="label">保费</div>
          <div class="text-box">
            <div class="text1">{{ renewalDetail.payFee }}元</div>
          </div>
        </div>
        <div class="detail-item">
          <div class="label">服务费率</div>
          <div class="text1">{{ renewalDetail.newCommission * 1 ? (renewalDetail.newCommission * 1).mul(100) + '%' : '-' }}</div>
        </div>
        <div class="detail-item">
          <div class="label">服务费</div>
          <div class="text-box">
            <div class="text1 org-text">{{ renewalDetail.newCommissionPrice ? renewalDetail.newCommissionPrice + '元' : '—' }}</div>
            <div class="btn2 btn-blue" @click="goServiceDetail(renewalDetail.newPolicyNo, renewalDetail.orderId)">服务费明细<i class="icon-right"></i></div>
          </div>
        </div>
      </div>
      <div class="tab-box" v-if="renewalDetail.payState == 2 || renewalDetail.payState == 3" >
        <div class="tab-item" :class="{ active: tabId == 1 }" @click="tabId = 1">变更记录</div>
        <div class="tab-item" :class="{ active: tabId == 2 }" @click="tabId = 2">原保单详情</div>
      </div>
      <!-- 变更记录 -->
      <followUpRecordsGroup v-show="tabId == 1" :renewalDetail="renewalDetail" />
      <!-- 保单详情 -->
      <orderDetailGroup v-show="tabId == 2" :renewalDetail="renewalDetail" />
    </div>

    <div class="bottom-box" v-if="hasBtn">
      <template v-if="renewalDetail.payState == 1 || renewalDetail.payState == 3">
        <div class="bottom-btn2" @click="goInsureList()">
          <span>人员清单</span>
        </div>
        <div class="bottom-btn3 ok-bgcolor" @click="lookPDF()">
          <span>电子保单</span>
        </div>
      </template>

      <div
        class="bottom-btn3 ok-bgcolor"
        @click="generateOrder()"
        v-if="renewalDetail.payState == 1 && renewalDetail.sourceType == 1 && !renewalDetail.detailUrl"
      >
        <span>生成续保订单</span>
      </div>
      <div
        class="bottom-btn3 ok-bgcolor"
        @click="goPolicyDetail()"
        v-else-if="(renewalDetail.payState == 1 && renewalDetail.sourceType == 1) || (renewalDetail.payState == 2 && renewalDetail.orderId)"
      >
        <span>查看续保订单</span>
      </div>
    </div>
  </div>
</template>
<script>
import { common } from '@/api/mixins';
import orderDetailGroup from './components/orderDetailGroup';
import followUpRecordsGroup from './components/followUpRecordsGroup';
import openTextModal from './components/openTextModal';
import Clipboard from 'clipboard';
export default {
  name: 'apps.renewal.detailGroup',
  mixins: [common],
  components: {
    orderDetailGroup,
    followUpRecordsGroup,
    openTextModal
  },
  data() {
    return {
      id: '',
      tabId: '2',
      renewalDetail: {}
    };
  },
  computed: {
    hasBtn() {
      return this.renewalDetail.payState == 1 || this.renewalDetail.payState == 3 || (this.renewalDetail.payState == 2 && this.renewalDetail.orderId);
    }
  },
  async created() {
    if (!this.checkLogin()) {
      return;
    }
    this.id = this.$route.query.id;
    this.tabId = this.$route.query.tabId || '1';
    this.getRenewalDetail();
    this.$weixin.hideMenu();
  },
  methods: {
    // 获取续期数据
    getRenewalDetail() {
      this.loading = true;
      this.$http({
        type: 'GET',
        url: '/api/groupPolicyRenewalRecord/read/detail',
        data: {
          id: this.id
        }
      })
        .then(res => {
          const data = res.data;
          if (data.contract) {
            data.contract = JSON.parse(data.contract);
            if (data.contract.length > 0) {
              data.contract = data.contract.map(item => item.url);
            }
          }
          if(data.payState == 1) {
            this.tabId = '2';
          }
          this.renewalDetail = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copy(id, text) {
      var clipboard = new Clipboard('#' + id, {
        text: trigger => {
          return text;
        }
      });
      clipboard.on('success', e => {
        this.$notice.msg('复制成功');
        console.log(e);
        // 释放内存
        clipboard.destroy();
      });
    },
    // 人员清单
    goInsureList() {
      const detail = this.renewalDetail;
      this.$router.push({
        path: '/apps/groupOrder/insureList',
        query: {
          policyNo: detail.policyNo,
          orderNo: detail.orderNo
        }
      });
    },
    // 电子保单
    lookPDF() {
      const detail = this.renewalDetail;
      if (detail.entrance != 1 && detail.contract) {
        if (detail.contract.length == 0) {
          this.$notice.msg('电子保单暂未生成');
        } else if (detail.contract.length > 1) {
          this.$router.push({
            path: '/apps/order/policyList',
            query: {
              insuranceContract: JSON.stringify(detail.contract)
            }
          });
        } else {
          if (this.$config.isApp) {
            let url = detail.contract[0];
            this.$app.readPdf({
              url,
              title: '电子保单'
            });
          } else {
            this.$app.openWeb(detail.contract[0]);
          }
        }
        return;
      }
      if (detail.policyUrl) {
        this.$tools.getHealthTest('APP_ORDER_DOWNLOAD_ELECTRONICPOL');
        if (this.$config.isApp) {
          this.$app.readPdf({
            url: detail.policyUrl,
            title: '电子保单'
          });
        } else {
          this.$app.openWeb(detail.policyUrl);
        }
      } else {
        this.$notice.msg('电子保单暂未生成');
      }
    },
    // 跳转结算明细
    goServiceDetail(policyNo, orderNo) {
      this.$router.push({
        path: '/apps/groupOrder/serviceDetail',
        query: {
          policyNo,
          orderNo
        }
      });
    },
    // 生成订单
    generateOrder() {
      const loading = this.$notice.loading();
      this.$http({
        url: '/api/groupPolicyRenewalRecord/generateRenewalOrder',
        type: 'POST',
        data: {
          id: this.renewalDetail.id,
          policyNo: this.renewalDetail.policyNo
        }
      }).then(res => {
        this.$app.openWeb(res.data, null, 'partner');
      }).finally(()=>{
        this.$notice.hideLoading(loading);
      });
    },
    // 跳转新保单详情
    goPolicyDetail() {
      const detail = this.renewalDetail;
      if (!detail.orderId) {
        this.$notice.msg('暂未创建续保订单');
        return;
      }
      if (detail.payState == 1 && detail.detailUrl) {
        this.$app.openWeb(detail.detailUrl, null, 'partner');
        return;
      }
      this.goPage('/apps/groupOrder/detail', { orderNo: detail.orderId, policyNo: detail.newPolicyNo });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './detail.scss';
</style>
